var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "li",
    {
      ref: "rootRef",
      staticClass: "issue-item",
      class: {
        "issue-item--active": _vm.isActive,
        "issue-item--has-locations": _setup.hasLocations,
        "issue-item--open": _setup.hasLocations && _setup.isExpanded,
        "issue-item--rejected": _setup.isRejected,
      },
      attrs: { "data-issue-id": _vm.issue.id },
      on: {
        click: _setup.onClickCard,
        mouseenter: _setup.onMouseEnterCard,
        mouseleave: _setup.onMouseLeaveCard,
      },
    },
    [
      !_setup.hasLocations
        ? [
            _vm.issue.manuscriptLevel ||
            _vm.issue.aiPriority ||
            _setup.displayIssueTypeLabel ||
            _vm.issue.line > 0
              ? _c("div", { staticClass: "issue-item__headline" }, [
                  _vm.issue.aiPriority
                    ? _c("span", { staticClass: "issue-item__metadata-chip" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _setup.t(
                                `proofreadingReviseManuscriptPage.aiPriority.${_vm.issue.aiPriority}`
                              )
                            ) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                  _setup.headlineText
                    ? _c("p", { staticClass: "issue-item__headline-text" }, [
                        _vm._v(_vm._s(_setup.headlineText)),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.issue.foreshadow
              ? _c("div", { staticClass: "issue-item__foreshadow" }, [
                  _c("p", { staticClass: "issue-item__foreshadow-row" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _setup.t(
                            "proofreadingReviseManuscriptPage.foreshadowItem"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" " + _vm._s(_vm.issue.foreshadow.item) + " "),
                  ]),
                  _vm.issue.foreshadow.storyChangesHeading
                    ? _c("p", { staticClass: "issue-item__foreshadow-row" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _setup.t(
                                "proofreadingReviseManuscriptPage.foreshadowHeading"
                              )
                            )
                          ),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.issue.foreshadow.storyChangesHeading) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                  _c("p", { staticClass: "issue-item__foreshadow-row" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _setup.t(
                            "proofreadingReviseManuscriptPage.foreshadowPlants"
                          )
                        )
                      ),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.issue.foreshadow.plantsSeen ||
                            _setup.t(
                              "proofreadingReviseManuscriptPage.foreshadowPlantsEmpty"
                            )
                        ) +
                        " "
                    ),
                  ]),
                  _vm.issue.text
                    ? _c("p", { staticClass: "issue-item__foreshadow-row" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _setup.t(
                                "proofreadingReviseManuscriptPage.originalTextLabel"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" " + _vm._s(_vm.issue.text) + " "),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _setup.displaySummary
              ? _c("p", { staticClass: "issue-item__summary" }, [
                  _vm._v(_vm._s(_setup.displaySummary)),
                ])
              : _vm._e(),
            _setup.displaySuggestionText
              ? _c(
                  "div",
                  { staticClass: "issue-item__text-suggestion-wrapper" },
                  [
                    _c("div", { staticClass: "issue-item__text-suggestion" }, [
                      _vm._v(
                        _vm._s(
                          _setup.t(
                            "proofreadingReviseManuscriptPage.suggestionLabel"
                          )
                        )
                      ),
                    ]),
                    _c(
                      "p",
                      {
                        staticClass: "issue-item__text",
                        attrs: { "data-status": _vm.issue.status },
                      },
                      [_vm._v(_vm._s(_setup.displaySuggestionText))]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        : [
            _c(
              "div",
              { staticClass: "issue-item__header" },
              [
                _c("div", { staticClass: "issue-item__header-main" }, [
                  _setup.displayIssueTypeLabel
                    ? _c("p", { staticClass: "issue-item__category" }, [
                        _vm._v(_vm._s(_setup.displayIssueTypeLabel)),
                      ])
                    : _vm._e(),
                  _c("p", { staticClass: "issue-item__summary" }, [
                    _vm._v(_vm._s(_setup.displaySummary)),
                  ]),
                ]),
                _c(_setup.IconChevronDown, {
                  staticClass: "issue-item__chevron",
                  attrs: { "aria-hidden": "true" },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "issue-item__locations-wrapper",
                class: {
                  "issue-item__locations-wrapper--open": _setup.isExpanded,
                },
                attrs: { "aria-hidden": !_setup.isExpanded },
              },
              [
                _c(
                  "ul",
                  { staticClass: "issue-item__locations" },
                  _vm._l(_vm.issue.locations, function (location) {
                    return _c(
                      "li",
                      {
                        key: location.id,
                        staticClass: "issue-item__location-row",
                        class: {
                          "issue-item__location-row--active":
                            !_vm.activeLocationIds?.length ||
                            _vm.activeLocationIds.includes(location.id),
                        },
                        attrs: { "data-issue-id": location.id },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _setup.onClickLocation(location)
                          },
                          mouseenter: function ($event) {
                            return _setup.onMouseEnterLocation(location)
                          },
                          mouseleave: function ($event) {
                            return _setup.onMouseLeaveLocation(location)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "issue-item__location-row-position" },
                          [
                            _vm._v(
                              _vm._s(_setup.formatLocationRowPosition(location))
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          { staticClass: "issue-item__location-original" },
                          [
                            _vm._v(
                              _vm._s(
                                _setup.t(
                                  "proofreadingReviseManuscriptPage.originalTextWithValue",
                                  { text: location.text }
                                )
                              )
                            ),
                          ]
                        ),
                        !location.applied &&
                        _setup.getLocationStatus(location) !== "rejected"
                          ? _c(
                              "div",
                              {
                                staticClass: "issue-item__location-suggestion",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "issue-item__location-label" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _setup.t(
                                          "proofreadingReviseManuscriptPage.suggestionLabel"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "issue-item__location-actions",
                                  },
                                  _vm._l(
                                    _setup.getLocationCandidates(),
                                    function (candidate) {
                                      return _c(
                                        "button",
                                        {
                                          key: candidate,
                                          staticClass: "issue-item__candidate",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _setup.onApplyLocation(
                                                location,
                                                candidate
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(candidate) + " ")]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                        location.applied
                          ? _c(
                              "div",
                              { staticClass: "issue-item__location-actions" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "issue-item__apply issue-item__apply--undo",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _setup.onRevertLocation(location)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_setup.revertLabel) + " "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        !location.applied
                          ? _c(
                              "div",
                              { staticClass: "issue-item__location-actions" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "issue-item__reject",
                                    class: {
                                      "issue-item__reject--rejected":
                                        _setup.getLocationStatus(location) ===
                                        "rejected",
                                    },
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _setup.onRejectToggleLocation(
                                          location
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _setup.getLocationRejectLabel(
                                            location
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ],
      !_setup.hasLocations
        ? _c("div", { staticClass: "issue-item__actions" }, [
            _vm.issue.fixable && !_vm.issue.applied && !_setup.isRejected
              ? _c(
                  "button",
                  {
                    staticClass: "issue-item__apply",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _setup.onApply.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_setup.applyLabel) + " ")]
                )
              : _vm._e(),
            _vm.issue.fixable === false &&
            !_vm.issue.applied &&
            !_setup.isRejected
              ? _c(
                  "button",
                  {
                    staticClass: "issue-item__apply",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _setup.onApply.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_setup.markDoneLabel) + " ")]
                )
              : _vm._e(),
            _vm.issue.applied
              ? _c(
                  "button",
                  {
                    staticClass: "issue-item__apply issue-item__apply--undo",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _setup.onRevert.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_setup.revertLabel) + " ")]
                )
              : _vm._e(),
            !_vm.issue.applied
              ? _c(
                  "button",
                  {
                    staticClass: "issue-item__reject",
                    class: {
                      "issue-item__reject--rejected": _setup.isRejected,
                    },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _setup.onRejectToggle.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_setup.rejectLabel) + " ")]
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }